module.exports = __webpack_public_path__ + "static/media/dandy-email.8f3a8a3c.png";